const toInt = (value, fallback = 0) => {
	const parsed = parseInt(value, 10);
	return Number.isNaN(parsed) ? fallback : parsed;
};

export const hasRemovableIngredients = (product) => {
	if (!Array.isArray(product?.ingredients)) return false;
	return product.ingredients.some((ingredient) => ingredient?.removable == 1);
};

export const hasProductCustomizations = (product) => {
	const hasVariants = Array.isArray(product?.variants_categories) && product.variants_categories.length > 0;
	return hasVariants || hasRemovableIngredients(product);
};

const pushSelection = (target, categoryId, item, qty = 1) => {
	if (!item) return 0;
	const normalizedQty = toInt(qty, 1);
	if (normalizedQty <= 0) return 0;
	target.push({
		variant_category_id: categoryId,
		id: item.id,
		qty: normalizedQty,
	});
	return normalizedQty;
};

export const getDefaultProductConfiguration = (product) => {
	const variants = [];
	const products = [];
	let hasRequiredSelections = false;

	if (!Array.isArray(product?.variants_categories)) {
		return { variants, products, notes: "", hasRequiredSelections };
	}

	for (const variantsCategory of product.variants_categories) {
		const categoryId = variantsCategory.id;
		let selectedCount = 0;
		const isQtySelectorCategory = toInt(variantsCategory.max) > 1 && toInt(variantsCategory.force_mono) === 0;
		const isCheckboxCategory = toInt(variantsCategory.force_mono) === 1;

		if (isQtySelectorCategory) {
			for (const variant of variantsCategory.variants || []) {
				selectedCount += pushSelection(
					variants,
					categoryId,
					variant,
					toInt(variant?.is_default) > 0 ? 1 : 0
				);
			}
			for (const variant of variantsCategory.variants2 || []) {
				selectedCount += pushSelection(
					variants,
					categoryId,
					variant,
					toInt(variant?.is_default) > 0 ? 1 : 0
				);
			}
			for (const subproduct of variantsCategory.products || []) {
				selectedCount += pushSelection(
					products,
					categoryId,
					subproduct,
					toInt(subproduct?.is_default) > 0 ? 1 : 0
				);
			}
		} else if (isCheckboxCategory) {
			for (const variant of variantsCategory.variants2 || []) {
				selectedCount += pushSelection(
					variants,
					categoryId,
					variant,
					toInt(variant?.is_default) > 0 ? 1 : 0
				);
			}
			if ((variantsCategory.products || []).length === 1) {
				selectedCount += pushSelection(products, categoryId, variantsCategory.products[0], 1);
			} else {
				for (const subproduct of variantsCategory.products || []) {
					selectedCount += pushSelection(
						products,
						categoryId,
						subproduct,
						toInt(subproduct?.is_default) > 0 ? 1 : 0
					);
				}
			}
		} else {
			const radioVariant =
				[...(variantsCategory.variants || []), ...(variantsCategory.variants2 || [])].find(
					(variant) => toInt(variant?.is_default) > 0
				) || null;
			const radioSubproduct =
				(variantsCategory.products || []).find((subproduct) => toInt(subproduct?.is_default) > 0) || null;

			if (radioVariant) selectedCount += pushSelection(variants, categoryId, radioVariant, 1);
			else if (radioSubproduct) selectedCount += pushSelection(products, categoryId, radioSubproduct, 1);
		}

		if (selectedCount < toInt(variantsCategory.min)) hasRequiredSelections = true;
	}

	return {
		variants,
		products,
		notes: "",
		hasRequiredSelections,
	};
};
